export default __webpack_public_path__ + "static/media/joomla.d55b33ab.svg";